import { FormControl, InputLabel, Select } from "@material-ui/core";
import axios from "axios";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { ContextMenuTrigger, MenuItem } from "react-contextmenu";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { useUserRights } from "../../../contexts/UserRightsContext";
import { contextualFormatter } from "../../fomatters/ContextualFormatter";
import { dateFormatter } from "../../fomatters/DateFormatter";
import Crud from "../Crud";

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function UsersOnline() {
  const [userType, setUserType] = useState(0);
  const [selectedRow, setSelectedRow] = useState(null);
  const [refreshInterval, setRefreshInterval] = useState(5);
  const crudRef = useRef(null); // Referencia para el componente Crud

  const [pendingAction, setPendingAction] = useState(null);

  const handleMenuClick2 = (e, data, row) => {
    setSelectedRow(row);
    setPendingAction(data.item);
  };

  useEffect(() => {
    if (selectedRow && pendingAction) {
      switch (pendingAction) {
        case "Refresh":
          if (crudRef.current) {
            crudRef.current.requestData();
          }
          break;
        case "Release All":
          Release(selectedRow);
          break;
        case "Release":
          Release(selectedRow);
          break;
        case "Info":
          Info(selectedRow);
          break;
        default:
          break;
      }
      setPendingAction(null);
    }
  }, [selectedRow, pendingAction]);


  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("userInfo"))
  );

  let history = useHistory();

  const onUserTypeChanged = useCallback((event) => {
    setUserType(event.target.value);
  }, []);
  const handleIntervalChange = (e) => {
    setRefreshInterval(e.target.value);
  };

  const systemFormatter = (value) => {
    switch (value) {
      case "M":
        return "Manager";
      case "N":
        return "Lines Manager";
      case "L":
        return "Call Center";
      case "R":
        return "Racing Client";
      case "B":
        return "Bet Ticker";
      case "I":
        return "Web Client";
      case "J":
        return "Don Best Game Importer";
      default:
        return value;
    }
  };

  const handleMenuClick = (e, data, row) => {
    setSelectedRow(row);
    switch (data.item) {
      case "Refresh":
        if (crudRef.current) {
          crudRef.current.requestData(); // Llamar a requestData del Crud
        }
        break;
      case "Release All":
        ReleaseAll();
        break;
      case "Release":
        Release();
        break;
      case "Info":
        Info();
        break;
      default:
        break;
    }
  };

  const ReleaseAll = () => {
    // Implementación de ReleaseAll
    if (selectedRow) {
      console.log("selectedRow====>", selectedRow);
      let request = {
        LogonSessionID: selectedRow.logonSessionID,
        IdUser: userInfo.userId,
      };
      const url = `${process.env.REACT_APP_API2_URL}/User/UserLogons_DeleteAll`;
      axios
        .post(url, request)
        .then((response) => {
          if (response.data === -1) {
            toast.success("Released");
            if (crudRef.current) {
              crudRef.current.requestData();
            }
          }
        })
        .catch((error) => {
          toast.error("Error");
          console.error("There was an error releasing the player!", error);
        });
    } else {
      console.log("No row selected");
    }
  };

  const Release = () => {
    // Implementación de Release utilizando el row seleccionado
    if (selectedRow) {
      console.log("selectedRow====>", selectedRow);
      let request = {
        LogonSessionID: selectedRow.logonSessionID,
        IdUser: userInfo.userId,
      };
      const url = `${process.env.REACT_APP_API2_URL}/User/UserLogons_Delete`;
      axios
        .post(url, request)
        .then((response) => {
          if (response.data === -1) {
            toast.success("Released");
            if (crudRef.current) {
              crudRef.current.requestData();
            }
          }
        })
        .catch((error) => {
          toast.error("Error");
          console.error("There was an error releasing the player!", error);
        });
    } else {
      console.log("No row selected");
    }
  };
  const Info = () => {
    // Implementación de Info utilizando el row seleccionado
    if (selectedRow) {
      let pushURL = "/user/" + selectedRow.idUser;
      console.log("URL====>", pushURL);
      return (
        <React.Fragment>
          <div>
            {history.push(pushURL)}
          </div>
        </React.Fragment>
      );
    } else {
      console.log("No row selected");
    }
  };

  const preventDefaultContextMenu = (e) => {
    e.preventDefault();
  };

  const { data: rights } = useUserRights();
  const hasRights = useCallback(
    (...ids) => ids.some((id) => rights?.includes(id)),
    [rights]
  );

  const handleRenderMenu = (row) => (
    <>
      <MenuItem
        data={{ item: "Info" }}
        onClick={(e, data) => handleMenuClick2(e, data, row)}
      >
        User Info
      </MenuItem>
      <MenuItem
        disabled={!hasRights(543)}
        data={{ item: "Release" }}
        onClick={(e, data) => handleMenuClick2(e, data, row)}
      >
        Release
      </MenuItem>
      <MenuItem
        disabled={!hasRights(472)}
        data={{ item: "Release All" }}
        onClick={(e, data) => handleMenuClick2(e, data, row)}
      >
        Release All
      </MenuItem>
      <MenuItem
        data={{ item: "Refresh" }}
        onClick={(e, data) => handleMenuClick2(e, data, row)}
      >
        Refresh
      </MenuItem>
    </>
  );

  return (
    <div
      className="flex flex-col gap-4 h-max"
      onContextMenu={preventDefaultContextMenu}
    >
      <div className="!gap-4 horizontal-options">
        <FormControl size="small" variant="outlined">
          <InputLabel shrink id="demo-simple-select-placeholder-label-label">
            User Type
          </InputLabel>

          <Select
            className="w-full"
            value={userType}
            onChange={onUserTypeChanged}
            displayEmpty
          >
            <MenuItem value={0}>Normal</MenuItem>
            <MenuItem value={3}>Services</MenuItem>
          </Select>
        </FormControl>
      </div>
      <ContextMenuTrigger id="contextmenu">
        <Crud
          interval={refreshInterval * 1000} // Convertir a milisegundos
          title="Logged Users"
          getUrl={() => `/User/UsersOnline_List`}
          getProcess={(data) => data.filter(({ type }) => type === userType)}
          onRequestData={() => { }} // Callback vacío
        >
          <TableHeaderColumn hidden isKey dataField="logonSessionID">
            LogonSessionID
          </TableHeaderColumn>
          <TableHeaderColumn hidden dataField="idUser">
            IdUser
          </TableHeaderColumn>
          <TableHeaderColumn
            filter={{ type: "TextFilter", delay: 1000 }}
            dataField="loginName"
            dataSort
            dataFormat={(cell, row) =>
              contextualFormatter(cell, row, "logonSessionID", handleRenderMenu)
            }
          >
            User
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="system"
            dataSort
            dataFormat={systemFormatter}
          >
            System
          </TableHeaderColumn>
          <TableHeaderColumn dataField="phoneLine" dataSort>
            Phone Line
          </TableHeaderColumn>
          <TableHeaderColumn dataField="ip" dataSort>
            IP
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="loginTime"
            dataFormat={dateFormatter}
            dataSort
          >
            Login Time
          </TableHeaderColumn>
          <TableHeaderColumn dataField="player" dataSort>
            Player On Call
          </TableHeaderColumn>
        </Crud>
      </ContextMenuTrigger>
      <div className="flex items-center gap-2">
        <label>Refresh every:</label>
        <input
          type="number"
          value={refreshInterval}
          onChange={handleIntervalChange}
          className="p-1 border rounded"
          min="1"
        />
        <span>seconds</span>
      </div>
    </div>
  );
}

export default UsersOnline;
